import authService from '../api-authorization/AuthorizeService'
//import * as XLSX from 'xlsx/xlsx.mjs';
import * as XLSX from 'xlsx-js-style';

export default class ReporteAdminService {
    async ReporteAdmin(semana) {
        const token = await authService.getAccessToken();
        var queryString = '?semana_Id=' + semana.semana_Id;
        const reporteResponse = await fetch('api/ReporteAdmin' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        let heading = [['ID Paleta', 'ORIGIN', 'PACKING_DATE', 'GROWER', 'PACKING', 'BRAND', 'FRUIT', 'VARIETY', 'DESCRIPTION', 'BOX_WEIGHT', 'BOXES_ON_PALLET',
            'VESSEL_NAME', 'VOYAGE_NUMBER', 'LOAD_PORT', 'LOAD_DATE', 'CONTAINER', 'DECK', 'HOLD', 'ART', 'SUPPLIER', 'CONTAINER', 'FINCA', 'PUERTO']];
        let rows = await reporteResponse.json();
        rows.forEach(function (v) {
            delete v.semana_Id;
            v.packinG_DATE = getFormattedDate(v.packinG_DATE);
            v.loaD_DATE = getFormattedDate(v.loaD_DATE);
            return v;
        });
        console.log("ReporteAdmin",rows);
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(worksheet, heading);
        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(worksheet, rows, { origin: 'A2', skipHeader: true });

        var style_h1 = {
            fill: { fgColor: { rgb: "92D050" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        var style_h2 = {
            fill: { fgColor: { rgb: "FFD966" } },
            alignment: { horizontal: "center", vertical: "top" },
            font: {
                name: 'Calibri',
                sz: 11,
                //color: { rgb: "#FF000000" },
                bold: true,
                italic: false,
                underline: false,
            },
            border: {
                top: { style: "thin", color: { auto: 1 } },
                right: { style: "thin", color: { auto: 1 } },
                bottom: { style: "thin", color: { auto: 1 } },
                left: { style: "thin", color: { auto: 1 } }
            }
        }
        const columns = [
            "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W"
        ];
        var wscols = [];
        for (let i = 0; i < columns.length; i++) {
            if (i == 0) {
                wscols.push({ wch: 17 })
            }
            else if (i == 1) {
                wscols.push({ wch: 8.71 })
            }
            else if (i == 2) {
                wscols.push({ wch: 15.57 })
            }
            else if (i == 3) {
                wscols.push({ wch: 20.43 })
            }
            else if (i == 4) {
                wscols.push({ wch: 10.29 })
            }
            else if (i == 5) {
                wscols.push({ wch: 18.14 })
            }
            else if (i == 6) {
                wscols.push({ wch: 8.29 })
            }
            else if (i == 7) {
                wscols.push({ wch: 15.14 })
            }
            else if (i == 8) {
                wscols.push({ wch: 23.43 })
            }
            else if (i == 9) {
                wscols.push({ wch: 14.14 })
            }
            else if (i == 10) {
                wscols.push({ wch: 19 })
            }
            else if (i == 11) {
                wscols.push({ wch: 16.29 })
            }
            else if (i == 12) {
                wscols.push({ wch: 18.29 })
            }
            else if (i == 13) {
                wscols.push({ wch: 16.29 })
            }
            else if (i == 14) {
                wscols.push({ wch: 12.71 })
            }
            else if (i == 15) {
                wscols.push({ wch: 14 })
            }
            else if (i == 16) {
                wscols.push({ wch: 6.86 })
            }
            else if (i == 17) {
                wscols.push({ wch: 7.43 })
            }
            else if (i == 18) {
                wscols.push({ wch: 8 })
            }
            else if (i == 19) {
                wscols.push({ wch: 10.43 })
            }
            else if (i == 20) {
                wscols.push({ wch: 14 })
            }
            else if (i == 21) {
                wscols.push({ wch: 14 })
            }


        }
        worksheet['!cols'] = wscols; // ws - worksheet
        for (var c = 0; c < (columns.length); c++) {
            var r = 0;
            var cell = columns[c] + (r + 1);
            if (worksheet[cell] == null) {
                continue;
            }
            if (["B1", "J1", "P1", "S1", "T1"].includes(cell)) {
                worksheet[cell].s = style_h2

            }
            else {
                worksheet[cell].s = style_h1
            }
        }
        worksheet['!autofilter'] = { ref: "A1:W1" };
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        /* create an XLSX file and try to save to Presidents.xlsx */
        XLSX.writeFile(workbook, "ReporteAdmin_" + semana.nombre + ".xlsx", { compression: true });
    }

}
function getFormattedDate(date) {
    date = new Date(date)
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return day + '/' + month + '/' + year;
}